import { render, staticRenderFns } from "./FinancePacksRoiCompact.vue?vue&type=template&id=65b0cea2&scoped=true&"
import script from "./FinancePacksRoiCompact.vue?vue&type=script&lang=js&"
export * from "./FinancePacksRoiCompact.vue?vue&type=script&lang=js&"
import style0 from "./FinancePacksRoiCompact.vue?vue&type=style&index=0&id=65b0cea2&lang=scss&scoped=true&"
import style1 from "./FinancePacksRoiCompact.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b0cea2",
  null
  
)

export default component.exports